import '@web/shared-digital-library/icons/svg-utilities/star-empty.svg';
import '@web/shared-digital-library/icons/svg-utilities/star-full.svg';
import '@web/shared-digital-library/icons/svg-utilities/star-half-white.svg';
import '@web/shared-digital-library/icons/svg-utilities/star-half-orange.svg';
import '@web/shared-digital-library/icons/svg-utilities/star-half-dark.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon.vue';
export default {
  name: 'RatingStars',
  components: {
    MdmIcon
  },
  props: {
    rating: {
      type: Number,
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    },
    size: {
      type: String,
      default: '12'
    }
  },
  computed: {
    allStars() {
      var container = [];
      for (var i = 0; i < this.enabledStarsCount; i++) {
        container.push('star-full');
      }
      if (this.halfEnabledStar) {
        container.push(this.starHalfName);
      }
      for (var j = 0; j < this.disabledStarsCount; j++) {
        container.push('star-empty');
      }
      return container;
    },
    enabledStarsCount() {
      return Math.floor(this.rating);
    },
    disabledStarsCount() {
      return 5 - Math.ceil(this.rating);
    },
    halfEnabledStar() {
      return !Number.isInteger(this.rating);
    },
    starHalfName() {
      if (this.theme === 'dark') return 'star-half-white';
      if (this.theme === 'orange') return 'star-half-orange';
      return 'star-half-dark';
    }
  },
  methods: {
    getClassStar(starType) {
      if (starType === 'star-full') {
        return {
          'fill-white': this.theme === 'dark',
          'fill-orange': this.theme === 'orange'
        };
      }
      return {
        'fill-gray': this.theme === 'dark',
        'fill-light-gray': this.theme === 'light' || this.theme === 'orange'
      };
    }
  }
};